var STATE_CLOSED = '0';
var STATE_SUBMITTED = '1';
var sessionStorageAvailable = function sessionStorageAvailable() {
  return typeof sessionStorage !== 'undefined';
};
var formWasSubmitted = function formWasSubmitted(locationId) {
  var state = null;
  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem("emailcapture-".concat(locationId));
  }
  return state === STATE_SUBMITTED;
};
var setFormAsClosed = function setFormAsClosed(locationId) {
  if (sessionStorageAvailable() && !formWasSubmitted(locationId)) {
    sessionStorage.setItem("emailcapture-".concat(locationId), STATE_CLOSED);
  }
};
var setFormAsSubmitted = function setFormAsSubmitted(locationId) {
  if (sessionStorageAvailable()) {
    sessionStorage.setItem("emailcapture-".concat(locationId), STATE_SUBMITTED);
  }
};
var formWasClosed = function formWasClosed(locationId) {
  var state = null;
  if (sessionStorageAvailable()) {
    state = sessionStorage.getItem("emailcapture-".concat(locationId));
  }
  return state === STATE_CLOSED;
};
export { setFormAsClosed, setFormAsSubmitted, formWasSubmitted, formWasClosed };